import { HintBubble } from '@/components/game/ui'

/**
 * Shared hover explanation of what Prestige is. Drop it inside any element that
 * has `group/tip relative` and shows a prestige value, so the concept is
 * explained everywhere it surfaces. Single source of truth for the wording.
 */
export function PrestigeHint({ placement = 'top' }: { placement?: 'top' | 'bottom' }) {
  return (
    <HintBubble
      placement={placement}
      className="w-60"
      label={
        <>
          <span className="font-semibold text-sand-200">Prestige</span>, ta renommée de capitaine. Contrairement
          à tes ressources, ta flotte et tes îles (remises à zéro à chaque saison), il se cumule d'une saison à
          l'autre : un fait d'armes refait la saison suivante te repaie son prestige, et ton total monte d'autant.
          Il récompense tes hauts faits : classements et bonus de fidélité à venir. Jamais à l'achat.
        </>
      }
    />
  )
}
